import { getEnvironDomain } from "ati-utils";
import initAxios from "./initAxios";

class WhoisApi {
  constructor() {
    const baseUrl = getEnvironDomain();
    this.axios = initAxios({
      baseURL: `//api.${baseUrl}`,
      withCredentials: true,
    });
  }

  getUserCountryLocale = () => this.axios.get("/whois");
}

export default WhoisApi;
